export default __webpack_public_path__ + "static/festl-oberammergau-preview-766e79c1839b113fbd8febfb2b89fea8.jpg";